import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRef } from "react";

import { USER_CACHE_KEY } from "./keys";

import { UserFilters } from "@/types";
import { UserRepository } from "@/repositories/user";

export const useGetAllUsers = (filters: UserFilters) => {
  const userRepository = useRef(new UserRepository());

  return useQuery({
    queryKey: [USER_CACHE_KEY, filters],
    queryFn: async () => {
      return await userRepository.current.findAll(filters);
    },
    placeholderData: keepPreviousData,
  });
};
